
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css'; // For annotations like links
import 'react-pdf/dist/Page/TextLayer.css'; 


  const PDFViewer = ({ pdfUrl }: any) => {

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

    const onDocumentLoadSuccess = ({ numPages } : any) => {
      setNumPages(numPages);
    }

    return (
      <div>
        <Document
          file={pdfUrl} // Can be a URL, base64 string, or Uint8Array
          onLoadSuccess={onDocumentLoadSuccess}
          scale={0.9}
        >
          <Page pageNumber={1} />
        </Document> 
    
        {/* Optional: Add navigation buttons for multiple pages */}
        {/* {numPages > 1 && (
          <div>
            <button onClick={() => setPageNumber(prev => Math.max(1, prev - 1))}>
              Previous
            </button>
            <button onClick={() => setPageNumber(prev => Math.min(numPages, prev + 1))}>
              Next
            </button>
          </div>
        )} */}
      </div>
    );
  }

  export default PDFViewer;